import FileDetail from '@/components/FileSearch/Mobile/FileDetail';
import { showPopup } from './modal';
export const showMobileFileDetail = (data) => {
    showPopup(
        <FileDetail data={data}></FileDetail>,
        { bodyStyle: { borderTopLeftRadius: '8px', borderTopRightRadius: '8px', minHeight: '20vh' } },
        'fileDetail'
    );
};
